// Small equippable name badge chip shown beside a username.
// Prefers illustrated PNG assets; falls back to tone + glyph chips.

import React from "react";

const PUBLIC = process.env.PUBLIC_URL || "";

export default function NameBadgeChip({
    badge = null,
    size = "md",
    className = "",
    title: titleOverride = null,
}) {
    if (!badge) {
        return null;
    }

    const tone = String(badge.badgeTone || badge.visualKey || "gold");
    const rarity = String(badge.badgeRarity || "").toLowerCase();
    const glyph = String(badge.badgeGlyph || badge.name?.[0] || "•");
    const label = titleOverride || badge.name || "Badge";
    const assetSrc = badge.assetSrc ? `${PUBLIC}${badge.assetSrc}` : null;

    return (
        <span
            className={[
                "nameBadgeChip",
                assetSrc ? "nameBadgeChip--image" : `nameBadgeChip--${tone}`,
                `nameBadgeChip--${size}`,
                rarity ? `nameBadgeChip--rarity-${rarity}` : "",
                className,
            ]
                .filter(Boolean)
                .join(" ")}
            title={label}
            aria-label={label}
        >
            {assetSrc ? (
                <img
                    className="nameBadgeChip__image"
                    src={assetSrc}
                    alt=""
                    aria-hidden="true"
                    draggable={false}
                />
            ) : (
                <span className="nameBadgeChip__glyph" aria-hidden="true">
                    {glyph}
                </span>
            )}
        </span>
    );
}
